declare namespace $ {

	type $mol_paragraph__title_giper_balls_requisites_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_giper_balls_requisites_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_labeler__title_giper_balls_requisites_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_giper_balls_requisites_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_paragraph__title_giper_balls_requisites_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_labeler__title_giper_balls_requisites_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_giper_balls_requisites_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_list__rows_giper_balls_requisites_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	export class $giper_balls_requisites extends $mol_page {
		Title( ): $mol_paragraph
		OGRNIP_value( ): $mol_paragraph
		OGRNIP( ): $mol_labeler
		INN_value( ): $mol_paragraph
		INN( ): $mol_labeler
		Info( ): $mol_list
		title( ): string
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=requisites.view.tree.d.ts.map